import {
    URLAPI,
    WORK_PROCESS_PATH,
    WORK_PROCESS_CREATE_PATH,
    WORK_PROCESS_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_work_process: {
        data: [],
        status: 0,
        message: {},
    },
    _create_work_process: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_process: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_WORK_PROCESS = "GET_ALL_WORK_PROCESS";
export const CREATE_WORK_PROCESS = "CREATE_WORK_PROCESS";
export const UPDATE_WORK_PROCESS = "UPDATE_WORK_PROCESS";

export const work_process_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_WORK_PROCESS:
            return {
                ...state,
                _get_all_work_process: action.payload,
            };
        case CREATE_WORK_PROCESS:
            return {
                ...state,
                _create_work_process: action.payload,
            };
        case UPDATE_WORK_PROCESS:
            return {
                ...state,
                _update_work_process: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllWorkProcess = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${WORK_PROCESS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_WORK_PROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_WORK_PROCESS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_WORK_PROCESS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createWorkProcess = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_PROCESS_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_PROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_PROCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_PROCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkProcess = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_PROCESS_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_PROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_PROCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_PROCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const searchProcess = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${WORK_PROCESS_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const clear_work_process = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
